import { useEffect, useMemo, useState } from 'react';
import { useStore } from 'components/Store';
import usePopulateMapData from 'hooks/usePopulateMapData';
import { FETCH_TYPES } from 'helpers/constants';
import { getCropZonesFromProperties } from 'helpers/propertyHelpers';

const useHasCropZonesInCropSeasons = (): boolean => {
  const [hasCropZonesInCropSeasons, setHasCropZonesInCropSeasons] = useState<
    boolean
  >(false);
  const {
    state: { cropSeasons }
  } = useStore();

  const initialSelectedCropSeasonIds = useMemo(
    () => JSON.parse(localStorage.getItem('selectedCropSeasons') || '[]'),
    []
  );

  const {
    dataSorted: propertyLandingPageData,
    reloadData
  } = usePopulateMapData({
    fetchType: FETCH_TYPES.propertiesMap,
    cropSeasonsId: initialSelectedCropSeasonIds,
    isCacheOn: true
  });

  useEffect(() => {
    const selectedCropSeasons = JSON.parse(
      localStorage.getItem('selectedCropSeasons') || '[]'
    );

    if (selectedCropSeasons.length > 0) {
      reloadData({ seasonIds: selectedCropSeasons });
    }
  }, [cropSeasons, reloadData]);

  useEffect(() => {
    const selectedCropSeasons = JSON.parse(
      localStorage.getItem('selectedCropSeasons') || '[]'
    );

    const activeCropZoneIds = new Set(
      (getCropZonesFromProperties(propertyLandingPageData?.properties) ?? [])
        .filter((cropZone: any) => !cropZone.archived)
        .map((cropZone: any) => cropZone.id)
    );

    setHasCropZonesInCropSeasons(
      (cropSeasons || []).some(
        (cropSeason: any) =>
          selectedCropSeasons.includes(cropSeason.id) &&
          cropSeason.cropZoneIds?.some((cropZoneId: string) =>
            activeCropZoneIds.has(cropZoneId)
          )
      )
    );
  }, [cropSeasons, propertyLandingPageData]);

  return hasCropZonesInCropSeasons;
};

export default useHasCropZonesInCropSeasons;
